import { createAsyncThunk } from '@reduxjs/toolkit';
import { doReQuote } from 'selective_solder_fixtures/api/quote';
import { selectDataForCart } from 'selective_solder_fixtures/store/selectors';
import { buildFormData } from 'selective_solder_fixtures/store/builder';
import { orderProduct } from 'shared/api/apiOrder';

export const doQuote = createAsyncThunk(
  'ssf/doQuote',
  async (_args, thunkAPI) => {
    const currentState = thunkAPI.getState();
    const { parameters, variantId } = currentState.ssf;
    const authToken = document.getElementsByName('authenticity_token')[0].value;

    return doReQuote(
      parameters,
      authToken,
      variantId,
      parameters.product_quote_number,
    );
  },
  {
    condition: ({ name }) => {
      const alterPrice = [
        'carrier_thickness',
        'carrier_length',
        'carrier_width',
        'hold_down_board_quantity',
        'pallet_need_stiffener_bar',
      ];

      if (!alterPrice.includes(name)) {
        return false;
      }

      return true;
    },
  },
);


export const addToCart = createAsyncThunk(
  'ssf/addToCart',
  async (_args, thunkAPI) => {
    const currentState = thunkAPI.getState();
    const { parameters, variantId, quantity } = selectDataForCart(currentState);
    const form = buildFormData({ parameters, variantId, quantity });

    // eslint-disable-next-line no-undef
    const inputFile = $('#filename');
    const file = inputFile ? inputFile.prop('files')[0] : null;

    if (file) {
      form.append('parameters[filename]', file);
    }

    return orderProduct(form);
  },
);